import { Box, Skeleton } from '@mui/material';
import { memo } from 'react';
import { useSelector } from 'react-redux';

import {
    getPropertyItem,
    propertyItemLoading,
} from 'features/fetchPropertyById/model/selectors/fetchPropertyByIdSelectors';
import { maxWidthContent } from 'shared/const/styles';

import { PropertyCardContactInfo } from './PropertyCardContactInfo';
import { PropertyCardInfo } from './PropertyCardInfo';
import { PropertyCardMainInfo } from './PropertyCardMainInfo';

export const PropertyCard = memo(() => {
    const propertyItem = useSelector(getPropertyItem);
    const loading = useSelector(propertyItemLoading);

    return (
        <Box maxWidth={maxWidthContent} display="flex">
            <>
                <Box
                    bgcolor="grey.300"
                    padding="16px"
                    borderRadius="12px 0 0 12px"
                    overflow="hidden"
                    flexBasis="50%"
                >
                    {loading ? (
                        <Skeleton
                            variant="rounded"
                            height="400px"
                            width="100%"
                        />
                    ) : (
                        <PropertyCardMainInfo propertyItem={propertyItem} />
                    )}
                </Box>
                <Box
                    padding="16px"
                    flexBasis="50%"
                    borderRadius="0 12px 12px 0"
                    border="1px solid"
                    borderColor="grey.500"
                >
                    {loading ? (
                        <Skeleton
                            variant="rounded"
                            height="140px"
                            width="100%"
                            sx={{ marginBottom: '32px' }}
                        />
                    ) : (
                        <PropertyCardInfo
                            propertyItem={propertyItem}
                            mb="32px"
                        />
                    )}

                    {loading ? (
                        <Skeleton
                            variant="rounded"
                            height="460px"
                            width="100%"
                        />
                    ) : (
                        <PropertyCardContactInfo
                            propertyItem={propertyItem?.allContacts}
                        />
                    )}
                </Box>
            </>
        </Box>
    );
});
